export default {"src":"/_next/static/media/chevron.8affecae.svg","height":25,"width":24};